//
import competitionUserRutes from './compeitionUser.js'

import PanelNavigation from '../views/panel/PanelNavigation.vue'

const panelRutes = [
  {
    path: '/ds',
    component: () => import('../views/panel/IndexPanelPage.vue'),
    meta: {requiresAuth: true},
    children: [
      {
        path: '',
        name: 'panel',
        component: PanelNavigation,
        meta: {requiresAuth: true},
        children: [
          {
            path: '',
            name: 'home-user',
            component: () => import('../views/panel/PanelHome.vue'),
          },
          {
            path: '/ds/fixture/creator/',
            name: 'panel-fixture-creator',
            component: () => import('../views/tools/FixtureCreatorPanelPage.vue'),
          },
          {
            path: '/ds/resultados/simulador/',
            name: 'panel-resultados-simulador',
            component: () => import('../views/tools/SimulatorResultsPage.vue'),
          },
          {
            path: 'tool',
            name: 'panel-tools',
            component: () => import('../views/tools/PanelTools.vue'),
          },
          {
            path: 'torneos',
            component: () => import('../views/panel/PanelTorneo.vue'),
            children: [
              {
                path: '',
                name: 'torneos-user',
                component: () => import('../views/panel/PanelTorneoSiguiendo.vue'),
              },
              {
                path: 'ranking',
                name: 'torneos-user-ranking',
                component: () => import('../views/panel/PanelRankingTorneo.vue'),
              },
              {
                path: 'mios',
                name: 'torneos-user-mios',
                component: () => import('../views/panel/PanelMisTorneos.vue'),
                query: null,
              },
            ]
          },
          {
            path: 'equipos',
            component: () => import('../views/panel/PanelEquipos.vue'),
            children: [
              {
                path: '',
                name: 'equipos-user',
                component: () => import('../views/panel/PanelEquiposSiguiendo.vue'),
              },
              {
                path: 'mios',
                name: 'equipos-user-mios',
                component: () => import('../views/panel/PanelMisEquipos.vue'),
              },
            ]
          },
          {
            path: 'news',
            component: () => import('../views/panel/PanelNews.vue'),
            children: [
              {
                path: '',
                name: 'news-user',
                component: () => import('../views/panel/PanelNoticiasUser.vue'),
              },
              {
                path: 'blogds',
                name: 'news-ds',
                component: () => import('../views/panel/PanelBlogDs.vue'),
              },
            ]
          },
          // =======================================
          // =================== URLS PARA COMPONENTES DE TIENDA ========
          // =======================================
          {
            path: 'tienda',
            component: () => import('../views/tienda/PortadaTiendaPage.vue'),
            children: [
              {
                path: '',
                name: 'tienda',
                component: () => import('../views/tienda/HomeTiendaPage.vue'),
              },
              {
                path: 'componente-info/:idCompo',
                name: 'compo-detail',
                component: () => import('../views/tienda/DetalleCompoPage.vue'),
              },
            ]
          },
          {
            path: 'componente-pay/:idCompo/payment',
            name: 'compo-payment',
            component: () => import('../views/tienda/PaymentCompoPage.vue'),
          },
          {
            path: 'user/stars/buy/',
            name: 'buy-stars',
            component: () => import('../views/tienda/BuyStarsPage.vue'),
            query: null,
          },
          {
            path: 'componente-modifier/competition/buy-players/',
            name: 'buy-players',
            component: () => import('../viewshop/competicion/AddNumPlayersCompePage.vue'),
            query: null,
          },
          {
            path: 'componente-modifier/competition/manager-anuncio/',
            name: 'compe-manager-ads',
            component: () => import('../viewshop/competicion/ManageAnuncioCompePage.vue'),
          },
          {
            path: 'componente-modifier/torneo/manager-anuncio/',
            name: 'torneo-mov-manager-ads',
            component: () => import('../viewshop/competicion/ManageAnuncioTorneoPage.vue'),
          },
          // =======================================
          // ============FIN URLS TIENDA ===========
          // =======================================
          {
            path: 'perfil/invitaciones',
            name: 'user-ivitations',
            component: () => import('../views/users/InvitacionesTeamsPage.vue'),
          },
          {
            path: 'perfil/edit/:username',
            name: 'user-perfil',
            component: () => import('../views/users/PerfilPage.vue'),
            children: [
              {
                path: 'resume',
                name: 'user-mi-perfil',
                component: () => import('../views/users/ResumePerfilPage.vue'),
              },
              {
                path: 'mis-datos',
                name: 'user-edit-perfil',
                component: () => import('../views/users/EditDataUserProfilePage.vue'),
              },
            ]
          },
          {
            path: '/user/products/',
            name: 'user-products',
            component: () => import('../views/users/CompoSaleUserPage.vue'),
          },
          {
            path: '/user/ads/',
            name: 'user-ads',
            component: () => import('../viewshop/users/UsersAdsPage.vue'),
            children: [
              {
                path: 'competicion',
                name: 'user-ads-compe',
                component: () => import('../viewshop/users/UserCompeAdsPage.vue'),
              },
              {
                path: 'torneo',
                name: 'user-ads-torneo',
                component: () => import('../viewshop/users/UserTorneoAdsPage.vue'),
              },
            ]
          },
          {
            path: 'perfil/change/password',
            name: 'user-change-password',
            component: () => import('../views/users/ChangePasswordAcount.vue'),
          },
          {
            path: 'deportista/:username',
            name: 'user-public-profile',
            component: () => import('../views/users/PublicProfileUserPage.vue'),
          },
        ].concat(competitionUserRutes)
      },
      {
        path: 'search',
        component: () => import('../views/search/ResultadosBusqueda.vue'),
        children: [
          {
            path: 'todo',
            name: 'panel-resultados-busqueda',
            component: () => import('../views/search/ResultsTodoSearch.vue'),
          },
          {
            path: 'torneos',
            name: 'panel-resultados-busqueda-torneo',
            component: () => import('../views/search/ResultsTorneoSearch.vue'),
          },
          {
            path: 'equipos',
            name: 'panel-resultados-busqueda-equipo',
            component: () => import('../views/search/ResultsEquipoSearch.vue'),
          },
          {
            path: 'jugadores',
            name: 'panel-resultados-busqueda-jugador',
            component: () => import('../views/search/ResultsJugadorSearch.vue'),
          },
        ]
      },
    ]
  },
]

export default panelRutes